import { createReducer, on } from '@ngrx/store'

import { ResourceDataSlice } from '@flowx/designer/modules/core/dictionary/data-mapping.dictionary'

import { NodeSlicesActions } from '../actions/node-slices.actions'

export const nodeSlicesFeatureKey = 'nodeSlices'

export interface NodeSlicesState {
  [nodeDefId: number]: {
    nodeSlices: ResourceDataSlice[]
  }
}

export const initialState: NodeSlicesState = {}

export const nodeSlicesReducer = createReducer(
  initialState,
  on(NodeSlicesActions.getNodeSlicesSuccess, (state, { nodeSlices, nodeFlowxUuid }) => ({
    ...state,
    [nodeFlowxUuid]: {
      nodeSlices,
    },
  })),
  on(NodeSlicesActions.createNodeSliceSuccess, (state, { nodeSlice, nodeFlowxUuid }) => ({
    ...state,
    [nodeFlowxUuid]: {
      ...state[nodeFlowxUuid],
      nodeSlices: [...state[nodeFlowxUuid].nodeSlices, nodeSlice],
    },
  })),
  on(NodeSlicesActions.updateNodeSliceSuccess, (state, { nodeSlice, nodeFlowxUuid }) => ({
    ...state,
    [nodeFlowxUuid]: {
      ...state[nodeFlowxUuid],
      nodeSlices: state[nodeFlowxUuid].nodeSlices.map((slice) =>
        slice.id === nodeSlice.id ? nodeSlice : slice
      ),
    },
  })),
  on(NodeSlicesActions.cleanupNodeSlices, () => ({
    ...initialState,
  }))
)
